import './App.css';
import React, {useEffect, useState} from 'react';
import {getAccountProfile} from './services/api/messaging';
import {AuthContext} from "./context/AuthContext";
import RouterBase from "./components/RouterBase";
import {Flowbite} from "flowbite-react";
import customThemeConfig from "./css/customThemeConfig";
import { MomentExtensions } from "./services/moment-extensions";
import {BROKER} from "./services/constants/CompanyType";
import {getHasProjectAccess} from "./services/api/nextgen-api";


const App = () => {
    const [authData, setAuthData] = useState(null);

    const fetchAuthData = async () => {
        try {
            const data = await getAccountProfile();


            if (data) {
                let hasProjectAccess = false;

                if (data.type === BROKER && process.env.REACT_APP_FF_NG_RFI === '1' && process.env.REACT_APP_FF_NG_RFIPROJECT === '1') {
                    hasProjectAccess = await getHasProjectAccess();
                }

                const newAuthData = {
                    ...data,
                    hasProjectAccess,
                    accountType: data.type,
                    baseUrl: `${process.env.REACT_APP_APP_BASE_URL}/${data.type}/${data.company?.slug}`,
                    fetchAuthData: fetchAuthData
                };

                // Initialize moment locale based on company locale
                const userLocale = data.company?.locale || 'en-US';

                setAuthData(newAuthData);
            }

        } catch (error) {
            console.error('Error fetching messages:', error);
            setAuthData(null);
            // Set default locale on error
            MomentExtensions.setLocale('en-US');
        }
    };

    useEffect(() => {
            fetchAuthData().catch(console.error);
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        []);

    // Set moment locale when authData is first loaded or locale changes
    useEffect(() => {
        if (authData?.company?.locale) {
            const userLocale = authData.company.locale;
            MomentExtensions.setLocale(userLocale);
        } else {
            // Set default locale if no locale is specified
            MomentExtensions.setLocale('en-US');
        }
    }, [authData?.company?.locale]);


    if (!authData)
        return <div></div>;

    return (
        <AuthContext.Provider value={authData}>
            <Flowbite theme={{theme: customThemeConfig}}>
                <div className="App">
                    <RouterBase/>
                </div>
            </Flowbite>
        </AuthContext.Provider>
    );
};

export default App;
